import { useEffect } from 'react';

export const useOwlCarouselInit = () => {
    useEffect(() => {
        const initOwlCarousel = () => {
            if (typeof window !== 'undefined' && (window as any).jQuery && (window as any).jQuery.fn.owlCarousel) {
                const $ = (window as any).jQuery;
                
                // Inicializar Case Studies
                $('.case-studies-slider').owlCarousel({
                    items: 3,
                    loop: true,
                    margin: 30,
                    nav: false,
                    dots: false,
                    autoplay: true,
                    responsive: {
                        0: { items: 1 },
                        768: { items: 2 },
                        992: { items: 3 }
                    }
                });

                // Inicializar Testimonials
                $('.testimonials-slider').owlCarousel({
                    items: 2,
                    loop: true,
                    margin: 30,
                    nav: false,
                    dots: true,
                    autoplay: true,
                    responsive: {
                        0: { items: 1 },
                        768: { items: 2 }
                    }
                });

                // Inicializar Team
                $('.team-slider').owlCarousel({
                    items: 4,
                    loop: true,
                    margin: 0,
                    nav: true,
                    dots: false,
                    autoplay: true,
                    responsive: {
                        0: { items: 1 },
                        600: { items: 2 },
                        992: { items: 4 }
                    }
                });

                console.log('✅ Owl Carousels inicializados');
            } else {
                setTimeout(initOwlCarousel, 100);
            }
        };

        const timer = setTimeout(initOwlCarousel, 1000);
        return () => clearTimeout(timer);
    }, []);
};